// extracted by mini-css-extract-plugin
export default {"audioButton":"AudioButton_audioButton__MkmQ9"};